module.exports = __webpack_public_path__ + "img/ex-reset@3x.7b7ccbea.png";